import React from 'react';
import { Table, Card } from 'antd';
import { formatTimestamp } from 'utils/utils.js';
import { connect } from 'dva';
import styles from './Card.less';

@connect(({ merchantBusinessMy, loading }) => ({
  relateSchools: merchantBusinessMy.relateSchools,
  loading: loading.effects['merchantBusinessMy/fetchRelateSchools'],
}))
export default class RelateSchoolsCard extends React.Component {
  componentDidMount() {
    const { dispatch } = this.props;

    dispatch({ type: 'merchantBusinessMy/fetchRelateSchools' });
  }

  render() {
    const { relateSchools, loading } = this.props;

    const columns = [
      {
        title: '序号',
        dataIndex: '',
        render: (text, record, index) => index + 1,
      },
      {
        title: 'School ID',
        dataIndex: 'id',
      },
      {
        title: '名称',
        dataIndex: 'name',
      },
      {
        title: '关联日期',
        dataIndex: 'associateTime',
        render: val => formatTimestamp(val),
      },
    ];

    return (
      <Card
        title="关联学校"
        loading={loading}
        className={`${styles.root} ${styles.table}`}
        bordered={false}
      >
        <Table
          columns={columns}
          dataSource={relateSchools}
          rowKey="id"
          loading={loading}
          bordered
          pagination={false}
        />
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Merchant/Business/My/Card/RelateSchools.js